/**
 * 主题工具函数
 * 动态设置CSS变量，实现主题切换
 */
import platformConfig from '@/config/theme'

/**
 * 应用主题到CSS变量
 */
export function applyTheme() {
  const theme = platformConfig.theme
  const root = document.documentElement
  
  // 设置CSS变量
  root.style.setProperty('--primary-color', theme.primary)
  root.style.setProperty('--primary-light', theme.primaryLight)
  root.style.setProperty('--primary-dark', theme.primaryDark)
  root.style.setProperty('--primary-bg', theme.primaryBg)
  root.style.setProperty('--primary-gradient', theme.primaryGradient)
  
  root.style.setProperty('--sidebar-bg', theme.sidebarBg)
  root.style.setProperty('--sidebar-logo-bg', theme.sidebarLogoBg)
  root.style.setProperty('--sidebar-text', theme.sidebarText)
  root.style.setProperty('--sidebar-hover', theme.sidebarHover)
  
  // 设置favicon
  const favicon = document.querySelector('link[rel="icon"]')
  if (favicon && platformConfig.logo.favicon) {
    favicon.href = platformConfig.logo.favicon
  }
  
  // 在body上添加平台类名
  document.body.classList.add(`${platformConfig.code}-theme`)
}

/**
 * 获取主题配置
 */
export function getThemeConfig() {
  return platformConfig.theme
}

/**
 * 获取平台配置
 */
export function getPlatformConfig() {
  return platformConfig
}

/**
 * 获取Logo路径
 */
export function getLogo(type = 'sidebar') {
  return platformConfig.logo[type] || platformConfig.logo.sidebar
}

/**
 * 获取功能开关状态
 */
export function isFeatureEnabled(featureName) {
  return platformConfig.features[featureName] || false
}

export default {
  applyTheme,
  getThemeConfig,
  getPlatformConfig,
  getLogo,
  isFeatureEnabled
}
